import api from "@/api/api";
import { mergeUserData } from "@/utils/userUtils";
import i18n from "@/i18n/i18n";

export const checkout = (payload) => {
  return api.post("/checkout", payload);
};

export const upgrade = (payload) => {
  return api.post("/upgrade", payload);
};

export const success = (payload) => {
  return api.post("/success", payload);
};

export const cancel = (payload) => {
  return api.put("/payments/subscription/cancel", payload);
};

export const pause = (payload) => {
  return api.put("/payments/subscription/pause", payload);
};

export const resume = () => {
  return api.put("/payments/subscription/resume");
};

export const unpause = async (vm) => {
  try {
    await resume();
    vm.$store.dispatch("setUser", {
      ...mergeUserData(vm, vm.$store.state.user),
      isPaused: false,
    });
    vm.$showToastSuccess(i18n.t("account.subscription.unpausedSuccessfully"), {
      title: i18n.t("common.success"),
    });
  } catch (error) {
    vm.$showToastError(error.message, { title: i18n.t("common.error") });
  }
};

export const applyCoupon = (type) => {
  return api.put(`/payments/coupons/${type}`);
};

export const customerPortal = (payload) => {
  return api.post("/customer-portal", payload);
};

export const getStripeInfo = (stripeSubscriptionId) => {
  return api.get("/stripe-info", { params: { stripeSubscriptionId } });
};

export const getSubscriptionInfo = () => {
  return api.get("/subscription-info");
};
